import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import { useRef } from 'react';

const ProtectedRoute = () => {
  const { user, session, isAnonymous } = useAuth();
  const lastLogRef = useRef<string>('');

  // Create a unique signature for this render to prevent spam logging
  const currentState = `${!!user}-${!!session}-${isAnonymous}-${window.location.pathname}`;
  const shouldLog = lastLogRef.current !== currentState;
  
  if (shouldLog) {
    console.log('🔒 PROTECTED ROUTE CHECK:', {
      user: user ? { id: user.id, email: user.email } : null,
      session: !!session,
      isAnonymous,
      shouldRedirect: !user || !session || isAnonymous,
      currentPath: window.location.pathname,
    });
    lastLogRef.current = currentState;
  }

  // Redirect if no user/session OR if user is anonymous
  if (!user || !session || isAnonymous) {
    if (shouldLog) {
      console.log('🚫 PROTECTED ROUTE: Redirecting to /auth because:', {
        noUser: !user,
        noSession: !session,
        isAnonymous,
      });
    }
    return <Navigate to="/auth" replace />;
  }

  if (shouldLog) {
    console.log('✅ PROTECTED ROUTE: Access granted');
  }
  return <Outlet />;
};

export default ProtectedRoute;
